import {
    ColorPalette,
    DEFAULT_COLORS
} from 'elements/minute/sidebar/sidebarComponents/complex/ColorPalette';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { IImageV2WorldMarker } from 'react-give-me-map/dist/utils/world/worldTypes';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IImageV2WorldMarker;
    onColorChanged?: (color: string) => void;
}

export const ImageMarkerIconSection = (props: Props): JSX.Element => {
    return (
        <S_ImageMarkerIconSection className={props.className}>
            <SidebarSubsection title="Color" icon={{ iconName: 'palette' }}>
                <SidebarContent>
                    <ColorPalette
                        value={props.marker.elementData.generatedIconColor}
                        pickerAllowed
                        onChange={(color) => {
                            props.onColorChanged?.(color);
                        }}
                        colors={[...DEFAULT_COLORS, '#000000', '#ffffff']}
                    />
                </SidebarContent>
            </SidebarSubsection>
        </S_ImageMarkerIconSection>
    );
};

const S_ImageMarkerIconSection = styled.div``;
